import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { handleKeywordKeyPress } from "../../common/handleKeyWordPress";
import { verifyCodeUrl } from "../../common/infrastructure/endpoints";
import { post } from "../../common/infrastructure/requests";
import { actionCreator } from "../../common/common.reducer";

interface IEmailVerificationCode {
  email: string;
  onClose(): any;
}

const verifyCode = async (verificationCode: string) => {
  try {
    const resp = await post<any, { code: string }>(verifyCodeUrl, {
      code: verificationCode,
    });
    if (resp) return true;
    return false;
  } catch (e) {
    return false;
  }
};

export const EmailVerificationCode: React.FC<IEmailVerificationCode> = (
  props
) => {
  const [verificationCode, setVerificationCode] = React.useState<string>("");
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleAttemptVerify = async () => {
    if (verificationCode.length !== 4) {
      setErrorMessage(t("You have entered too few characters"));
      return;
    }

    const success = await verifyCode(verificationCode);
    if (!success) {
      setErrorMessage(t("You have entered an incorrect code"));
      return;
    }
    dispatch(actionCreator.setEmail(props.email));
    props.onClose();
    setErrorMessage("");
    setVerificationCode("");
  };

  return (
    <Grid container direction="column" wrap="nowrap">
      <DialogContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h3">{props.email}</Typography>
          <Button
            variant="text"
            color="secondary"
            //@ts-ignore
            onClick={() => props.previousStep()}
          >
            {t("Change")}
          </Button>
        </Box>
        <Typography>{t("Enter the code you received via email")}</Typography>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="_ _ _ _"
          required
          inputProps={{ type: "text", pattern: "d*", maxLength: 4 }}
          onChange={(e) => setVerificationCode(e.target.value)}
          helperText={errorMessage.length > 1 && errorMessage}
          onKeyDown={(e) => handleKeywordKeyPress(e, handleAttemptVerify)}
        />
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          <DialogContentText color="primary" style={{ margin: 0 }}>
            {t("Did not receive a code?")}
          </DialogContentText>
          <Box>
            <Button
              variant="text"
              color="secondary"
              //@ts-ignore
              onClick={() => props.previousStep()}
            >
              {t("Request new code")}
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          disabled={verificationCode.length !== 4}
          onClick={() => handleAttemptVerify()}
        >
          {t("Verify")}
        </Button>
      </DialogActions>
    </Grid>
  );
};
